import * as React from 'react';
import {
  ArticleComponentDataProps,
  FiniteScrollArticleComponentDataProps,
} from '../../templates/utils/articleComponent.utils';
import { ArticlePageViewEvent } from './ArticlePageViewEvent';
import { getCoverType } from '../../templates/templates.utils';
import { createBlockNames } from '../../store/template/postPage/utils/createBlockNames';

interface FiniteScrollNextArticlesProps {
  articles: Array<FiniteScrollArticleComponentDataProps>;
  articleComponent: React.FunctionComponent<ArticleComponentDataProps>;
}

interface ArticlePageViewEventWithMemoProps {
  article: FiniteScrollArticleComponentDataProps;
  numberOfArticleOnPage: number;
}
const ArticlePageViewEventWithMemoData: React.FunctionComponent<ArticlePageViewEventWithMemoProps> = props => {
  const { article, numberOfArticleOnPage, children } = props;
  const articleTemplateMemo = React.useMemo(() => createBlockNames(article.body), [article.body]);
  return (
    <ArticlePageViewEvent
      key={article.id}
      articleId={article.id}
      articleTemplate={articleTemplateMemo}
      channels={article.feeds}
      articleAuthor={article.ownerName}
      articleTitle={article.title}
      articlePublicationTime={article.createdAt}
      contentTags={article.tags}
      mainMedia={getCoverType(article.cover)}
      commercialTags={article.commercialTags}
      articleContentCount={article.articleContentCount}
      articleWordCount={article.articleWordCount}
      ownerUsername={article.ownerUsername}
      articleURL={article.articleUrl}
      createdAt={article.createdAtISO}
      isSlideshow={!!(article.slideshow && article.slideshow.totalSlides)}
      mainCategoryEmbed={!!article.breadCrumbs?.categoryLink}
      numberOfArticleOnPage={numberOfArticleOnPage}
    >
      {children}
    </ArticlePageViewEvent>
  );
};
export const FiniteScrollNextArticles: React.FunctionComponent<FiniteScrollNextArticlesProps> = props => {
  const { articles, articleComponent } = props;
  const [shouldRenderFiniteScrollArticles, setShouldRenderFiniteScrollArticles] = React.useState(false);
  const ArticleComponent = articleComponent;

  const scrollHandler = React.useCallback(() => {
    setShouldRenderFiniteScrollArticles(true);
  }, []);

  React.useEffect(() => {
    if (!shouldRenderFiniteScrollArticles) {
      window.addEventListener('scroll', scrollHandler);
    }
  }, [scrollHandler, shouldRenderFiniteScrollArticles]);

  React.useEffect(() => {
    if (shouldRenderFiniteScrollArticles) {
      window.removeEventListener('scroll', scrollHandler);
    }
  }, [scrollHandler, shouldRenderFiniteScrollArticles]);

  return shouldRenderFiniteScrollArticles
    ? (
      <React.Fragment>
        {articles.map((articleProps, index) => (
          <ArticlePageViewEventWithMemoData
            key={articleProps.id}
            article={articleProps}
            numberOfArticleOnPage={index + 2}
          >
            <ArticleComponent {...articleProps} />
          </ArticlePageViewEventWithMemoData>
        ))}
      </React.Fragment>
    )
    : null;
};
